<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-group v-for="(email, index) in form.emails" :key="email.index" :label-for="`input-email-${email.index}`">
      <template v-if="index===0" #label>
        Email address
      </template>
      <b-form-row class="align-items-center">
        <b-col>
          <b-form-input :id="`input-email-${email.index}`" v-model="email.email" :state="isValidField(`email-${email.index}`)" placeholder="name@example.com" class="rounded-pill" />
        </b-col>
        <b-col cols="1">
          <b-button v-if="index!==0" variant="link" class="btn-link-primary p-0" @click.prevent="onEmailRemoveClick(index)">
            <b-icon-x font-scale="2" />
          </b-button>
        </b-col>
      </b-form-row>
      <b-form-invalid-feedback :state="isValidField(`email-${email.index}`)">
        <div v-for="error in errors[`email-${email.index}`] || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-button v-if="showAddLink" variant="link" class="btn-link-primary" @click="onEmailAddClick">
      + Add another address
    </b-button>
    <b-form-row>
      <b-col />
      <b-col cols="auto" class="d-flex flex-column align-items-start">
        <b-button variant="link" class="btn-link-dark" @click.prevent="$emit('preview-invite')">
          <b-icon-eye-fill /> Preview invitation
        </b-button>
        <b-button variant="link" class="btn-link-dark" @click.prevent="$emit('invite-link')">
          <b-icon-link45deg /> Get an invite link to share
        </b-button>
      </b-col>
    </b-form-row>
    <b-form-row class="mt-5 ">
      <b-col md="auto" class="text-center mb-3">
        <b-button :disabled="submitting" pill variant="outline-primary" class="pl-5 pr-5" @click.prevent="$emit('back')">Back</b-button>
      </b-col>
      <b-col />
      <b-col md="auto" class="text-center">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Send invite and finish</b-button>
        <div>
          <b-button :disabled="submitting" variant="link" class="btn-link-primary mt-2" @click.prevent="$emit('skip')">or Skip and finish</b-button>
        </div>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import { BIconX, BIconEyeFill, BIconLink45deg } from 'bootstrap-vue'
import MixinForm from '../MixinForm'

const defaultEmails = [
  { index: 0, email: '' },
  { index: 1, email: '' },
  { index: 2, email: '' }
]

export default {
  name: 'InvitationForm',

  mixins: [MixinForm],

  props: {
    maxInvitations: {
      type: Number
    }
  },

  computed: {
    showAddLink() {
      return typeof this.maxInvitations === 'number' ? this.form.emails.length < this.maxInvitations : true
    }
  },

  data() {
    return {
      form: {
        emails: defaultEmails
      },
      nextIndex: defaultEmails.length
    }
  },

  methods: {
    onEmailAddClick() {
      this.form.emails.push({ index: this.nextIndex++, email: '' })
    },

    onEmailRemoveClick(index) {
      this.form.emails.splice(index, 1)
    },

    validate(data) {
      let hasEmails = false
      const errors = {}
      data.emails.forEach(email => {
        hasEmails = Boolean(email.email) || hasEmails
        if (email.email && !validator.isEmail(email.email.trim())) errors[`email-${email.index}`] = ['Email format is invalid']
      })

      if (!hasEmails) {
        const email = data.emails[0]
        errors[`email-${email.index}`] = ['Add at least one email']
      }
      return errors
    },

    prepare(data) {
      return { ...data, emails: data.emails.map(p => p.email).filter(Boolean).map(p => p.trim()) }
    }
  },

  components: {
    BIconX,
    BIconEyeFill,
    BIconLink45deg
  }
}
</script>
